import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
import { IconButtonSizeType, IconButtonVariantType, TextVariantType } from '../variants';
export const commonTokens = (FOUNDATIONS, VARIANT_TOKENS) => ({
    mainContainer: {
        width: '100%',
        height: 'auto',
        min_height: FOUNDATIONS.size_1125,
        position: 'relative',
        overflow: 'hidden',
        border_radius: FOUNDATIONS.radius_250,
        background_color: FOUNDATIONS.color_neutral_bg_static_100,
        border_width: FOUNDATIONS.border_25,
        border_style: 'solid',
        border_color: FOUNDATIONS.color_neutral_border_onsurface_100,
        padding: FOUNDATIONS.spacing_150,
        ...VARIANT_TOKENS.mainContainer,
    },
    headerContainer: {
        height: FOUNDATIONS.spacing_550,
        padding_top: FOUNDATIONS.spacing_150,
        padding_bottom: FOUNDATIONS.spacing_150,
        border_top_left_radius: FOUNDATIONS.radius_250,
        border_top_right_radius: FOUNDATIONS.radius_250,
        border_bottom_left_radius: FOUNDATIONS.radius_00,
        border_bottom_right_radius: FOUNDATIONS.radius_00,
        box_shadow: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_negative_100} ${FOUNDATIONS.blur_50} ${FOUNDATIONS.spread_00} ${FOUNDATIONS.color_effect_shadow_inner_50} inset`,
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
        pointer_events: 'none',
        ...VARIANT_TOKENS.headerContainer,
    },
    bodyContainer: {
        padding_top: FOUNDATIONS.spacing_250,
        padding_bottom: FOUNDATIONS.spacing_150,
        gap: FOUNDATIONS.spacing_200,
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        width: '100%',
        background_color: FOUNDATIONS.color_neutral_bg_static_100,
        ...VARIANT_TOKENS.bodyContainer,
    },
    iconButtonsShowHide: {
        variant: IconButtonVariantType.SECONDARY_ON_SURFACE,
        size: IconButtonSizeType.SMALL,
    },
    bodyTopContainer: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_100,
    },
    infoContainer: {
        holderText: {
            color: FOUNDATIONS.color_neutral_font_onsurface_50,
            font_variant: TextVariantType.FONT_PARAGRAPH_500,
            font_weight: FONT_WEIGHT.font_regular,
            text_align: TEXT_ALIGN.center,
        },
        title: {
            color: FOUNDATIONS.color_neutral_font_onsurface_50,
            font_variant: TextVariantType.FONT_PARAGRAPH_250,
            font_weight: FONT_WEIGHT.font_weight_600,
            text_align: TEXT_ALIGN.center,
        },
        info: {
            color: FOUNDATIONS.color_neutral_font_onsurface_50,
            font_variant: TextVariantType.FONT_PARAGRAPH_200,
            font_weight: FONT_WEIGHT.font_regular,
            text_align: TEXT_ALIGN.center,
        },
        infoContent: {
            display: 'flex',
            gap: FOUNDATIONS.spacing_150,
        },
        extraInfo: {
            color: FOUNDATIONS.color_neutral_font_onsurface_50,
            font_variant: TextVariantType.FONT_PARAGRAPH_350,
            font_weight: FONT_WEIGHT.font_regular,
            text_align: TEXT_ALIGN.center,
        },
    },
    decorativeTokens: {
        height: FOUNDATIONS.size_450,
        width: FOUNDATIONS.size_450,
        ...VARIANT_TOKENS.decorativeTokens,
    },
});
//# sourceMappingURL=commonTokens.js.map